<template>

  <base-dialog :show="error != null" :showCloseIcon="false" title="Something Fishy" @close="error == null">
            <template v-slot:content>                  
                    <div class="inv-wrapper nwd-wrap">
                        <div class="inv-form-item">
                                <label>{{error}}</label>    
                        </div>
                    </div>
            </template>
                <template v-slot:actions>
                    <base-button class="d-btn d-edit" @click="error=null" title="Close"><i class="fas fa-times"></i></base-button>                  
            </template>
  </base-dialog>


  <div class="admin-container">
    <NaviPanel />

    <main class="main-layout">
      <NaviHeader />

      <div class="content-scroll">

        <div class="cs-card">
            <h3>Formats</h3>
            <p class="text-tooltip">Define banner formats and assign them to banners used in campaigns.</p>
        </div>

        <div class="cs-card cs-animation">
          <div class="table-wrapper">

            <table class="format-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Width [px]</th>
                  <th>Height [px]</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="format in formats" :key="format.Id">
                  <td>{{ format.Name }}</td>
                  <td>{{ format.Width }}</td>
                  <td>{{ format.Height }}</td>
                  <td>
                    <button 
                      @click="deleteFormat(format.Id)" 
                      :disabled="format.Used === 1"
                      :class="[ 'app-icon', {'btn-disabled': format.Used === 1} ]"
                    >
                      <app-icon icon="hugeicons:delete-03" width="18" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="add-form">
            <h4>New Format</h4>
            <div class="form-group">
              <input v-model="newFormat.Name" placeholder="Name" />
              <input v-model.number="newFormat.Width" type="number" placeholder="Width" />
              <input v-model.number="newFormat.Height" type="number" placeholder="Height" />
              <button @click="addFormat" class="app-icon"><app-icon icon="hugeicons:credit-card-add" width="18" /></button>
            </div>
          </div>


        </div>

      </div>
    </main>
  </div>
</template>


<script>
    import NaviPanel from '@/components/NaviPanel.vue';
    import NaviHeader from '@/components/NaviHeader.vue';

    import shared from "@/shared";
    import apiService from "@/services/other.js";

    export default {
        components: { NaviPanel, NaviHeader},
        name: 'FormatsView',

        data: function () {
            return {
              error: null, 
              formats: [],
              newFormat: {
                Name: '',
                Width: null,
                Height: null
              }             
            };
        },
        created() {           
        },

        mounted() {
          this.formatList();
        },

        methods: {   
           
          formatList() {
            
                const data = {ResultName: "bannerList"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {                  
                            
                            this.formats = response.data;  

                            console.log(this.formats);
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '201', true, e));
          },

          deleteFormat(id) {
            const data = {ResultName: "bannerDel", BannerId: id};
            apiService
                .uniExec(data)
                .then((response) => {
                if (response.status === 200) {                  
                        this.formatList();
                }
                })
                .catch((e) => shared.handleError.call(this, '203', true, e));
          },

          addFormat() {
            if (!this.newFormat.Name || !this.newFormat.Width || !this.newFormat.Height) {
              
              return;
            }
            
            console.log("Dodawanie nowego formatu:", this.newFormat);
            
            const data = {ResultName: "bannerAdd", Name: this.newFormat.Name, Width: this.newFormat.Width, Height: this.newFormat.Height};
            apiService
                .uniExec(data)
                .then((response) => {
                if (response.status === 200) {                  
                        
                        this.formatList();
                }
                })
                .catch((e) => shared.handleError.call(this, '202', true, e));

            this.newFormat = { Name: '', Width: null, Height: null };
          }

        },


    }
</script>



<style scoped>

.table-wrapper {
  border: 1px solid #ddd; /* Przenosimy obramowanie na wrapper */
  border-radius: 8px;    /* Tutaj dzieje się magia */
  overflow: hidden;       /* To przycina rogi tabeli wewnątrz */
  margin-bottom: 20px;
  box-shadow: 0 1px 3px 0 rgba(50, 50, 93, 0.1), 0 1px 2px 0 rgba(50, 50, 93, 0.06);
}

.format-table {
  width: 100%;
  border-collapse: collapse; /* Teraz może zostać collapse */
  border: none;              /* Usuwamy główne obramowanie z tabeli */
  font-size: 14px;
}

/* Opcjonalnie: dodaj linie między komórkami, jeśli ich potrzebujesz */
.format-table td, .format-table th {
  border-bottom: 1px solid #ddd;
  text-align: center;
  padding: 5px;
  color: var(--text-theader);
}

.format-table th {
  background-color: var(--bg-page);
  font-size: 16px;
}

/* Usuwamy ostatnią linię, żeby nie dublowała się z ramką wrappera */
.format-table tr:last-child td {
  border-bottom: none;
}


.add-form {
    background: var(--bg-page);
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 rgba(50, 50, 93, 0.1), 0 1px 2px 0 rgba(50, 50, 93, 0.06);
}

.form-group {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}

.form-group input {
    margin-right: 10px;
    padding: 5px;
  }

</style>